import { render, staticRenderFns } from "./CreateSecurityConcernNew.vue?vue&type=template&id=61b06157&scoped=true"
import script from "./CreateSecurityConcernNew.vue?vue&type=script&lang=js"
export * from "./CreateSecurityConcernNew.vue?vue&type=script&lang=js"
import style0 from "./CreateSecurityConcernNew.vue?vue&type=style&index=0&id=61b06157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b06157",
  null
  
)

export default component.exports